import React from 'react';
import PropTypes from 'prop-types';
import Container from '../PageBuilder/lib/Container';
import Img from '../PageBuilder/lib/Image';

const AccentImageWidget = ({
  image,
  title,
  credits,
  description,
  descriptionPosition,
  containerSettings,
}) => (
  <Container settings={containerSettings}>
    <div className="accent-image">
      <div className={`flex-grid-three-and-nine ${descriptionPosition === 'description_right' ? 'row-reverse' : ''}`}>
        <div className="col">
          <h4>{title}</h4>

          {description === '' ? '' : <div className="description-text" dangerouslySetInnerHTML={{ __html: description }} />}
          {credits === '' ? '' : <small className="credits">{credits}</small>}
        </div>

        <div className="col">
          <Img src={image} variant="image" />
        </div>
      </div>
    </div>
  </Container>
);

AccentImageWidget.title = 'Accent Image';
AccentImageWidget.preview = 'image.png';
AccentImageWidget.category = 'Content';

AccentImageWidget.defaultProps = {
  containerSettings: {},
};

AccentImageWidget.propTypes = {
  image: PropTypes.any.isRequired,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  credits: PropTypes.string.isRequired,
  descriptionPosition: PropTypes.string.isRequired,
  containerSettings: PropTypes.object,
};

AccentImageWidget.defaults = {
  image: 'http://placehold.it/770x500',
  title: 'Title',
  credits: 'Credits',
  description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nostrum id culpa debitis adipisci illo, porro molestias quas quaerat ratione veritatis?',
  descriptionPosition: 'description_left',
};

AccentImageWidget.adminFields = {
  descriptionPosition: { type: 'select', options: [['description_right', 'Description right'], ['description_left', 'Description left']] },
  image: { type: 'image' },
  credits: { type: 'text' },
  title: { type: 'text' },
  description: { type: 'rich' },
};


export default AccentImageWidget;
